import {
    Box,
    Typography,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
import InputLine from "../ui/inputLine";
import SelectLine from "../ui/selectLine";
import {useTranslation} from "react-i18next";
import {PAGE_APPLICATIONS} from "../../../locales/pages/namespaces";

const Step3Form = ({ formik, counties,language,error,titles }) => {
    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        setFieldValue,
    } = formik;
    const {t} = useTranslation(PAGE_APPLICATIONS)
    const renderError = (name) =>
        touched[name] &&
        errors[name] && (
            <Typography sx={{ color: "red", fontSize: 13, mt: -1, mb: 2 }}>
                {errors[name]}
            </Typography>
        );
    const safeCounties = Array.isArray(counties) ? counties : (counties ? [counties] : []);
    return (
        <Box sx={{ mt: 6, maxWidth: 1280 }}>
            <Typography
                sx={{ fontWeight: 700, fontSize: 16, color: "#004B88", mb: 3 }}
            >
                {t("Organization legal representative")}
            </Typography>

            <Box sx={{ maxWidth: 820 }}>
                <Box sx={{maxWidth:"77%"}}>
                <SelectLine
                    label={t("Title")}
                    name="repTitle"
                    required
                    value={values.repTitle}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    options={titles.map(c => ({
                        value: c.id,
                        label: language === "el" ? c.NameEL : c.NameEN
                    }))}
                    error={touched.repTitle && errors.repTitle}
                    helperText={errors.repTitle}
                />
                </Box>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                    {language === 'el' &&
                        <InputLine
                        label={t("First name(in greek characters)")}
                        name="repFirstName"
                        required
                        value={values.repFirstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.repFirstName && errors.repFirstName}
                        helperText={errors.repFirstName}
                    />}
                    <InputLine
                        label={language === 'el'?t("First name(in latin characters"):t('First name')}
                        name="repFirstName_en"
                        required
                        value={values.repFirstName_en}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.repFirstName_en && errors.repFirstName_en}
                        helperText={errors.repFirstName_en}
                    />
                    {language === 'el' &&
                        <InputLine
                        label={t("Last name(in greek characters)")}
                        name="repLastName"
                        required
                        value={values.repLastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.repLastName && errors.repLastName}
                        helperText={errors.repLastName}
                    />}
                    <InputLine
                        label={language === 'el' ? t("Last name(in latin characters"): t('Last name')}
                        name="repLastName_en"
                        required
                        value={values.repLastName_en}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.repLastName_en && errors.repLastName_en}
                        helperText={errors.repLastName_en}
                    />
                    <InputLine
                        label={t("Position/Title")}
                        name="repPositionTitle"
                        required
                        value={values.repPositionTitle}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.repPositionTitle && errors.repPositionTitle}
                        helperText={errors.repPositionTitle}
                    />
                    {/*<SelectLine*/}
                    {/*    label={t("State/Prefecture")}*/}
                    {/*    name="repState"*/}
                    {/*    required*/}
                    {/*    value={values.repState}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    onBlur={handleBlur}*/}
                    {/*    options={safeCounties.map(c => ({*/}
                    {/*        value: c.Id,*/}
                    {/*        label: language === "el" ? c.NameEL : c.NameEN*/}
                    {/*    }))}*/}
                    {/*    error={touched.repState && errors.repState}*/}
                    {/*    helperText={errors.repState}*/}
                    {/*/>*/}
                    <InputLine
                        label={t("Zip code")}
                        name="repZip"
                        required
                        value={values.repZip}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.repZip && errors.repZip}
                        helperText={errors.repZip}
                    />
                    <InputLine
                        label={t("Mobile phone")}
                        name="repMobilePhone"
                        required
                        value={values.repMobilePhone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.repMobilePhone && errors.repMobilePhone}
                        helperText={errors.repMobilePhone}
                    />
                </Box>

                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                    <InputLine
                        label={t("Office phone")}
                        name="repFixedPhone"
                        value={values.repFixedPhone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                    <InputLine
                        label={t("Email")}
                        name="repEmail"
                        required
                        value={values.repEmail}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.repEmail && errors.repEmail}
                        helperText={errors.repEmail}
                    />
                </Box>
            </Box>
            <Box sx={{ mt: 4, maxWidth: 820 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={values.repIsContact}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setFieldValue("repIsContact", checked);

                                // If same person → clear contact fields
                                if (checked) {
                                    setFieldValue("contactTitle", "");
                                    setFieldValue("contactFirstName", "");
                                    setFieldValue("contactLastName", "");
                                    setFieldValue("contactPositionTitle", "");
                                    setFieldValue("contactState", "");
                                    setFieldValue("contactZip", "");
                                    setFieldValue("contactFixedPhone", "");
                                    setFieldValue("contactMobilePhone", "");
                                    setFieldValue("contactEmail", "");
                                }
                            }}
                            sx={{
                                color: "#004B88",
                                "&.Mui-checked": { color: "#004B88" },
                            }}
                        />
                    }
                    label={t(
                        "If your organization's legal representative is also the person responsible for the submission of this request, check this box. Otherwise, enter contact information below."
                    )}
                    sx={{ alignItems: "flex-start", color: "#004B88" }}
                />
            </Box>
            {!values.repIsContact && (
                <Box sx={{ mt: 6, maxWidth: 820 }}>
                    <Typography
                        sx={{ fontWeight: 700, fontSize: 16, color: "#004B88", mb: 3 }}
                    >
                        {t("Contact Details (if different from above)")}
                    </Typography>
                    <Box sx={{maxWidth:"77%"}}>
                        <SelectLine
                            label={t("Title")}
                            name="contactTitle"
                            required
                            value={values.contactTitle}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            options={titles.map(c => ({
                                value: c.id,
                                label: language === "el" ? c.NameEL : c.NameEN
                            }))}
                            error={touched.contactTitle && errors.contactTitle}
                            helperText={errors.contactTitle}
                        />
                    </Box>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                        {language === 'el' &&
                            <InputLine
                            label={t("First name(in greek characters)")}
                            name="contactFirstName"
                            value={values.contactFirstName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            error={touched.contactFirstName && errors.contactFirstName}
                            helperText={errors.contactFirstName}
                        />}
                        <InputLine
                            label={language === 'el'?t("First name(in latin characters"):t('First name')}
                            name="contactFirstName_en"
                            value={values.contactFirstName_en}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            error={touched.contactFirstName_en && errors.contactFirstName_en}
                            helperText={errors.contactFirstName_en}
                        />
                        {language === 'el' &&
                            <InputLine
                            label={t("Last name(in greek characters)")}
                            name="contactLastName"
                            value={values.contactLastName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            error={touched.contactLastName && errors.contactLastName}
                            helperText={errors.contactLastName}
                        />}
                        <InputLine
                            label={language === 'el' ? t("Last name(in latin characters"): t('Last name')}
                            name="contactLastName_en"
                            value={values.contactLastName_en}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            error={touched.contactLastName_en && errors.contactLastName_en}
                            helperText={errors.contactLastName_en}
                        />
                        <InputLine
                            label={t("Position/Title")}
                            name="contactPositionTitle"
                            value={values.contactPositionTitle}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            error={touched.contactPositionTitle && errors.contactPositionTitle}
                            helperText={errors.contactPositionTitle}
                        />
                        {/*<SelectLine*/}
                        {/*    label={t("State/Prefecture")}*/}
                        {/*    name="contactState"*/}
                        {/*    value={values.contactState}*/}
                        {/*    onChange={handleChange}*/}
                        {/*    onBlur={handleBlur}*/}
                        {/*    options={safeCounties.map(c => ({*/}
                        {/*        value: c.Id,*/}
                        {/*        label: language === "el" ? c.NameEL : c.NameEN*/}
                        {/*    }))}*/}
                        {/*    required*/}
                        {/*    error={touched.contactState && errors.contactState}*/}
                        {/*    helperText={errors.contactState}*/}
                        {/*/>*/}
                        <InputLine
                            label={t("Zip code")}
                            name="contactZip"
                            value={values.contactZip}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            error={touched.contactZip && errors.contactZip}
                            helperText={errors.contactZip}
                        />
                        <InputLine
                            label={t("Office phone")}
                            name="contactFixedPhone"
                            value={values.contactFixedPhone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                    </Box>

                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                        <InputLine
                            label={t("Mobile phone")}
                            name="contactMobilePhone"
                            value={values.contactMobilePhone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            error={touched.contactMobilePhone && errors.contactMobilePhone}
                            helperText= {t(
                                "Be sure to include your country code (e.g. +30 for Greece, +1 for the U.S., +33 for France)."
                            )}
                        />
                        <InputLine
                            label={t("Email")}
                            name="contactEmail"
                            value={values.contactEmail}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            error={touched.contactEmail && errors.contactEmail}
                            helperText={errors.contactEmail}
                        />
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default Step3Form;
